// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-content-row{padding-top:5px}@media only screen and (min-width:640px){.main-content-row{display:flex;padding:10px 0}}@media only screen and (min-width:1025px){.main-content-row{padding-bottom:10px}}.main-content-left{min-width:270px}.main-content-right{max-width:calc(100% - 270px);width:100%}.main-content-right--full-width{max-width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
